import { Position, Intent, Toaster as BPToaster } from '@blueprintjs/core';
const Toaster = BPToaster.create({
  className: 'hobs-toaster',
  position: Position.TOP
});

const mergeOptions = props => {
  let toastProps = {};
  if (typeof props === 'string') {
    toastProps.message = props;
    toastProps.intent = Intent.NONE;
  } else {
    toastProps = props;
  }
  return toastProps;
};

const success = (props, key) => {
  const toastProps = mergeOptions(props);
  toastProps.intent = Intent.SUCCESS;
  toastProps.icon = 'tick';
  Toaster.show(toastProps, key);
};

const error = (props, key) => {
  const toastProps = mergeOptions(props);
  toastProps.intent = Intent.DANGER;
  toastProps.icon = 'delete';
  Toaster.show(toastProps, key);
};

const info = (props, key) => {
  const toastProps = mergeOptions(props);
  toastProps.intent = Intent.WARNING;
  toastProps.icon = 'info-sign';
  Toaster.show(toastProps, key);
};

const warning = info;

export const Toast = {
  success,
  error,
  info,
  warning
};
